import React from "react";

const SettingsContext = React.createContext({
    settings: {}, // Provide default settings
    setSettings: (settings) => {}, // No-op function or some default implementation
  });

export default SettingsContext;
